<template>
  <GModal class="custom-modal modal-confirm-bp" :noscroll="true">
    <div slot="body">
      <a href="" class="modal-dismiss" @click.prevent="close()">
        <img src="/assets/img/icon-close-grey.svg" />
      </a>
      <p class="title">Lengkapi Beauty Profile</p>
      <p class="desc">
        Ayo lengkapi Beauty Profilemu untuk mendapatkan rekomendasi yang dikurasi khusus untuk kebutuhan kulit dan
        rambutmu.
        <br /><br /><b
          >Kamu juga akan mendapatkan 150
          <img src="/assets/img/icon-sp.svg" alt="SP" height="15" width="15" />
          Soco Point</b
        >
      </p>
      <a href="" class="button" @click.prevent="complete()">Lengkapi Sekarang</a>
      <p class="back">
        <a href="" @click.prevent="close()">Kembali ke halaman utama</a>
      </p>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-confirm-beauty-profile',
  computed: {
    user() {
      return this.$store.state.auth.userProfile;
    },
    showModal() {
      return this.$store.state.modal.isModalShow.confirmBP;
    },
  },
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmBP' });
    },
    complete() {
      this.close();
      if (
        Boolean(
          this.user.hasOwnProperty('birthday_date') && this.user.hasOwnProperty('country') && this.user.country.name
        )
      ) {
        this.$router.push('/beauty-profile');
      } else {
        this.$router.push('/register-detail');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  // confirm-bp modal
  .modal-confirm-bp {
    background: transparent;
    width: auto;
    height: auto;
    min-height: inherit;
    top: auto;
    bottom: 44px;
    left: 16px;
    position: fixed;
    z-index: 9999;
    & ::v-deep .modal-dialog {
      width: 480px;
      height: auto;
      margin: auto;
    }
    & ::v-deep .modal-content {
      margin: auto;
      border: 0;
      border-radius: 10px;
      box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.32);
      text-align: left;
      background: url('/assets/img/bg_popup_bp.svg') no-repeat;
      background-size: cover;
      padding: 10px;
      .modal-header {
        display: none;
      }
      .title {
        font-size: 16px;
        color: #444241;
        letter-spacing: normal;
        font-family: 'lato-bold', sans-serif;
      }
      .desc {
        font-size: 14px;
        color: #231f20;
        line-height: 21px;
        margin-top: 20px;
        margin-bottom: 25px;
        font-family: 'lato-regular', sans-serif;
        b,
        strong {
          font-family: 'lato-bold', sans-serif;
        }
      }
      .button {
        margin-top: 20px;
        width: 100%;
        letter-spacing: normal;
        background: #da2a52;
        color: #fff;
        margin: 6px 0 0;
        padding: 9px 0;
        display: block;
        text-align: center;
        border-radius: 4px;
        font: 13px/18px 'lato-bold', sans-serif;
      }
      .back {
        font-size: 12px;
        color: #b32656;
        text-align: center;
        line-height: 13px;
        margin-top: 20px;
        font-family: 'lato-regular', sans-serif;
      }
      .modal-dismiss {
        display: block;
        position: absolute;
        // background: url(/assets/img/icon-close-grey.svg) no-repeat center 100%;
        top: 15px;
        right: 5px;
      }
    }
    @media (max-width: 991px) {
      & ::v-deep .modal-content {
        margin: 0 15px;
        .title {
          font-size: 14px;
          letter-spacing: normal;
        }
        .desc {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
